import { render, staticRenderFns } from "./textCampaigns.vue?vue&type=template&id=0667e65b&scoped=true"
import script from "./textCampaigns.vue?vue&type=script&lang=js"
export * from "./textCampaigns.vue?vue&type=script&lang=js"
import style0 from "./textCampaigns.vue?vue&type=style&index=0&id=0667e65b&prod&scoped=true&lang=css"
import style1 from "./textCampaigns.vue?vue&type=style&index=1&id=0667e65b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0667e65b",
  null
  
)

export default component.exports